import * as React from 'react';
import { Image } from 'components';
import ImgWrapper from './styled';

declare type AvatarSizes = 'small' | 'medium' | 'large' | 'thumbnail';

const getSizeProps = (size: AvatarSizes) => {
  switch (size) {
    case 'small':
      return { maxHeight: 100, maxWidth: 100 };
    case 'medium':
      return { maxHeight: 152, maxWidth: 152 };
    case 'large':
      return { maxHeight: 200, maxWidth: 200 };
    case 'thumbnail':
    default:
      return { maxHeight: 50, maxWidth: 50 };
  }
};

export default function AdvisorAvatar({
  src,
  alt,
  height,
  width,
  size,
  placeholderImgURL
}: {
  src: string;
  alt: string;
  size?: AvatarSizes;
  placeholderImgURL?: string;
  height?: number;
  width?: number;
}): JSX.Element {
  const sizeProps = getSizeProps(size);
  return (
    <ImgWrapper>
      <Image
        src={src}
        alt={alt}
        placeholderImgURL={placeholderImgURL}
        height={height}
        width={width}
        {...sizeProps}
      />
    </ImgWrapper>
  );
}

AdvisorAvatar.defaultProps = {
  size: 'thumbnail',
  placeholderImgURL: '',
  height: '',
  width: ''
};
